export enum ECancelBroadbandEligibilityStatus {
    HAS_NO_BROADBAND_OFFER = "HAS_NO_BROADBAND_OFFER",
    HAS_WRONG_ORDER_STATUS = "HAS_WRONG_ORDER_STATUS",
    IS_TOO_LATE = "IS_TOO_LATE",
    IS_ELIGIBLE = "IS_ELIGIBLE",
}

export interface ICancelBroadbandEligibilityResponse {
    status: ECancelBroadbandEligibilityStatus;
}
